import React from "react";
import MultiSelectDropdown from "../../MultiSelectDropdown";
import LeftPanelViewSwitch from "./LeftPanelViewSwitch"

export default function OrdersFilters({
  filters,
  setFilters,
  categories,
  viewMode, 
  setViewMode,
  setSelectedOrderPositionIds,
  onChangeInput,
  onToggleTri,
}) {
  const handleInput = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleServiceChange = (e) => {
    const val = e.target.value;
    setFilters({
      ...filters,
      service: val === "all" ? null : val,
    });
  };

  return (
    <div className="card mb-3">
      <div className="card-body">

        {/* ------- Поиск ------- */}
        <div className="row g-2 mb-2">
          <div className="col-4">
            <input
              type="text"
              name="namePart"
              className="form-control"
              placeholder="Поиск по имени/артикулу"
              value={filters.namePart}
              onChange={handleInput}
            />
          </div>

          {/* ------- Категории ------- */}
          <div className="col-5">
            <MultiSelectDropdown
              options={categories}
              selectedIds={filters.categoryIds}
              onChange={(newIds) =>
                setFilters({ ...filters, categoryIds: newIds })
              }
              placeholderAll="Все категории"
              placeholderOne="Категория"
              placeholderMany="категорий"
            />
          </div>

          {/* ------- Сортировка ------- */}
          <div className="col-3 d-flex align-items-center">
            <select
              name="sortParam"
              className="form-select"
              value={filters.sortParam}
              onChange={handleInput}
            >
              <option value="time_desc">Время ↓ (новые)</option>
              <option value="time_asc">Время ↑ (старые)</option>

              <option value="article_desc">Артикул ↓</option>
              <option value="article_asc">Артикул ↑</option>
            </select>
          </div>
        </div>

        
        <div className="row g-2 mb-2">
          
          {/* ------- Сервис WB/OZON/Все ------- */}
          <div className="col-3">
            <select
              className="form-select"
              value={filters.service ?? "all"}
              onChange={handleServiceChange}
            >
              <option value="all">Все сервисы</option>
              <option value="WB">WB</option>
              <option value="OZON">OZON</option>
            </select>
          </div>

          <div className="col-3 align-items-center">
            <LeftPanelViewSwitch
            value={viewMode}
            onChange={(mode) => {
              setViewMode(mode);
              setSelectedOrderPositionIds([]); // сброс выделений
            }}
          />
          </div>

          {/* ------- Чекбокс 1 — Лак ------- */}
          <div className="col-3 d-flex align-items-center">
            <input
              type="checkbox"
              className="form-check-input ms-2 me-2"
              checked={filters.hasVarnish === true}
              ref={(el) => el && (el.indeterminate = filters.hasVarnish === null)}
              onChange={() =>
                setFilters({
                  ...filters,
                  hasVarnish:
                    filters.hasVarnish === null
                      ? true
                      : filters.hasVarnish === true
                      ? false
                      : null,
                })
              }
            />
            <label className="form-check-label">Лак</label>
          </div>

          {/* ------- Чекбокс 2 — QR коды ------- */}
          <div className="col-3 d-flex align-items-center">
            <input
              type="checkbox"
              className="form-check-input me-2"
              checked={filters.hasQrCodes === true}
              ref={(el) => el && (el.indeterminate = filters.hasQrCodes === null)}
              onChange={() =>
                setFilters({
                  ...filters,
                  hasQrCodes:
                    filters.hasQrCodes === null
                      ? true
                      : filters.hasQrCodes === true
                      ? false
                      : null,
                })
              }
            />
            <label className="form-check-label">QR коды</label>
          </div>
        </div>
      </div>
    </div>
  );
}
